<template>
  <div v-for="(item, index) in list.items" :key="index" class="cnt">
    <van-cell-group class="body kuang">
      <van-cell title="主办（实施）单位类型" :value="item.sponsorTypeTxt" />
      <van-cell
        v-if="item.sponsorTypeOther"
        title="其他主办（实施）单位类型"
        :value="item.sponsorTypeOther"
      />
      <van-cell title="活动（项目）名称" :value="item.name" />
      <van-cell title="活动（项目）主题" :value="item.activeThemesTxt" />
      <van-cell
        v-if="item.activeThemeOther"
        title="其他活动（项目）主题"
        :value="item.activeThemeOther"
      />
      <van-cell title="活动类型" :value="item.activeType" />
      <van-cell
        v-if="item.activeTypeOther"
        title="其他活动类型"
        :value="item.activeTypeOther"
      />
      <van-cell title="活动起止时间" :value="item.date" />
      <van-cell title="活动天数" :value="item.days" />
      <van-cell title="参加队员人数" :value="item.peopleNum" />
      <van-cell title="备注" :value="item.remarks" />
    </van-cell-group>
  </div>
</template>
<script>
export default {
  props: {
    list: Object,
  },
  setup() {
    return {};
  },
};
</script>
<style lang="less" scoped>
:deep(.van-cell__value) {
  flex: 2;
}
</style>
